module.exports = __webpack_public_path__ + "media/07.eb79dedf.mp4";